import * as React from 'react';
import { useState, useEffect } from 'react';
import { List, Datagrid, TextField, Button, SimpleList,EditButton} from 'react-admin';
import { TextField as MuiTextField, Box,useMediaQuery,Stack } from '@mui/material';
//import PasswordModal from './PasswordModal'; // Import PasswordModal
import RecordCreateDialog from './recordCreateDialog.tsx';
import AddIcon from '@mui/icons-material/Add';

const recordFilters = [
    <MuiTextField source="passwords" label="search" resettable={true}  />,
];

const PassmanList = (props) => {
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const [encryptionKey, setEncryptionKey] = useState('');
    const [passwordInput, setPasswordInput] = useState('');
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    useEffect(() => {
        const storedKey = localStorage.getItem('encryptionKey');
        if (storedKey) {
            setEncryptionKey(storedKey);
        }
    }, []);

    const handlePasswordConfirm = () => {
        if (passwordInput.trim() !== '') {
            localStorage.setItem('encryptionKey', passwordInput);
            setEncryptionKey(passwordInput);
            setPasswordInput('');
        }
    };

    return (
        <div>
            <List
                title="PASSLIST"
                sort={{ field: 'web', order: 'ASC' }}
                actions={
                    <Box  sx={{   marginRight: '1em'}}>
                       <Stack direction="row" spacing={5} alignItems="center" justifyContent="center">
                            
                            <MuiTextField
                                label="Encryption Key"
                                value={passwordInput}
                                onChange={(e) => setPasswordInput(e.target.value)}
                                style={{ marginLeft: '0em' }}
                            />
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={handlePasswordConfirm}
                                style={{  marginLeft: '1em',
                                    fontSize: '13px',
                                    padding: '10px 10px 10px 20px', // 增加内边距
                                    lineHeight: 1      // 调整行高
                                      }}
                            >
                                CONFIRM
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => setCreateDialogOpen(true)}
                                style={{ marginRight: '1em',
                                    fontSize: '13px',
                                    padding: '10px', // 增加内边距
                                    lineHeight: 1  

                                 }}
                            >
                                ADD
                            </Button>
                            </Stack>

               
                    </Box>
                }
            >
                {isSmall ? (
                    <SimpleList 
                    primaryText={record => record.web}
                    secondaryText={record =>record.pass?.slice(0, 20)} />
                ):(
                <Datagrid>
                    <TextField source="id" label="ID" />
                    <TextField source="web" label="WEB/APP" />
                    <TextField source="pass" label="PASSWORD" />
                    <EditButton /> {/* 添加 EditButton */}
                </Datagrid>
                )
            }
            </List>
            <RecordCreateDialog open={createDialogOpen} onClose={() => setCreateDialogOpen(false)} encryptionKey={encryptionKey} />
        </div>
    );
};

export default PassmanList;